import InvitationDTO from '../models/invitation';
import { AuthUserData } from '../models/user';
import { useAcceptInvitationMutation, useRejectInvitationMutation } from '../store';
import { toastError, toastSuccess } from '../utils/toasts';
import Button from './atoms/Button';
import CardFrame from './atoms/CardFrame';

interface Props {
  user: AuthUserData;
  invitation: InvitationDTO;
}

const JoinBusinessCard: React.FC<Props> = ({ user, invitation }) => {
  const [acceptInvitation, acceptResults] = useAcceptInvitationMutation();
  const [rejectInvitation, rejectResults] = useRejectInvitationMutation();

  const handleAccept = async () => {
    try {
      await acceptInvitation({ businessId: invitation.business_id, userId: user.id, token: invitation.token });
      toastSuccess('Invitación aceptada con éxito.');
      // usado para refrescar state
      window.location.href = `/admin/${invitation.business_id}/events`;
    } catch (e) {
      console.error(e);
      toastError('Error al aceptar invitación.');
    }
  };

  const handleReject = async () => {
    try {
      await rejectInvitation({ businessId: invitation.business_id, userId: user.id, token: invitation.token });
      toastSuccess('Invitación rechazada con éxito.');
      // usado para refrescar state
      window.location.href = '/admin/invitations';
    } catch (e) {
      console.error(e);
      toastError('Error al rechazar invitación.');
    }
  };

  return (
    <CardFrame>
      <div className="flex flex-col md:flex-row items-center gap-4 w-full">
        <p className="text-lg">{invitation.business.name}</p>
        <div className="flex gap-2 md:flex-row-reverse w-full md:w-fit max-w-sm md:ml-auto">
          <Button loading={rejectResults.isLoading} variant="secondary" onClick={handleReject}>
            Rechazar
          </Button>
          <Button loading={acceptResults.isLoading} variant="primary" onClick={handleAccept}>
            Aceptar
          </Button>
        </div>
      </div>
    </CardFrame >
  );
};

export default JoinBusinessCard;
